import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

const options = {
  responsive: true,
  plugins: {
    zoom: {
      pan: {
        enabled: true,
        mode: "x", // Allows panning only on X-axis
        modifierKey: "ctrl", // Hold Ctrl to pan
      },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        mode: "x", // Zoom only on X-axis
      },
    },
  },
  scales: {
    x: {
      beginAtZero: true,
    },
    y: {
      beginAtZero: true,
    },
  },
};

const BarChart = ({
  dateTimesLive,
  dataArrLive,
  getRandomColor,
  chartChannel,
  selectedTabIndex,
  channelsGroup,
  allChannelGroups
}) => {

  const [barChartData, setBarChartData] = useState([]);


  ChartJS.register(ArcElement, Tooltip, Legend);




  useEffect(() => {
    const availableChannels = dataArrLive.filter(
      (data, index) => data.data.slice(-1)[0] !== null
    );

    //available channel names
    const availableChannelsNames = availableChannels.map((data) => data.label);

    const lastValues = availableChannelsNames.map(
      (header, index) => dataArrLive[index].data.slice(-1)[0]
    );

    let barChartLabels = [...availableChannelsNames];
    let groupChannels = [];

    if (channelsGroup) {
      allChannelGroups.forEach((group) => {
        if (group.groupName === channelsGroup) {
          groupChannels = group.channels;
        }
      })
    }

    let channelsLastValues;

    if (groupChannels?.length > 0) {
      barChartLabels = [...groupChannels];
      channelsLastValues =
        groupChannels?.length > 0
          ? groupChannels.map(
            (chart, index) => {
              const matchedChannel = availableChannels.find(
                (channel) => channel.label === chart
              );
              return matchedChannel?.data?.slice(-1)[0]
            }
          )
          : lastValues;
    }




    if (chartChannel?.length > 0) {
      barChartLabels = [...chartChannel];
      channelsLastValues =
        chartChannel?.length > 0
          ? chartChannel.map(
            (chart, index) => {
              const matchedChannel = availableChannels.find(
                (channel) => channel.label === chart
              );
              return matchedChannel?.data?.slice(-1)[0]
            }
          )
          : lastValues;
    }

    const newPieChartData = {
      labels: barChartLabels,
      datasets: [
        {
          label: "Available Channels",
          data: channelsLastValues ? channelsLastValues : lastValues,
          backgroundColor: dataArrLive.map(() => getRandomColor()),
        },
      ],
    };

    setBarChartData(newPieChartData);
  }, [dateTimesLive, selectedTabIndex, chartChannel, channelsGroup]);

  return (
    <div>
      {barChartData && barChartData.labels ? (
        <Bar data={barChartData} options={options} />
      ) : (
        <p>Loading chart data...</p>
      )}
    </div>
  );
};

const NewBarChart = ({
  pieChartData,
  openNewPage,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  setPieChartData,
  chartChannel,
  tabIndexPieChart,
  selectedTabIndex,
  channelsGroup,
  allChannelGroups
}) => {
  const [newChartData, setNewChartData] = useState([]);

  ChartJS.register(ArcElement, Tooltip, Legend);

  useEffect(() => {

    const availableChannels = dataArrLive.filter(
      (data, index) => data.data.slice(-1)[0] !== null
    );

    //available channel names
    const availableChannelsNames = availableChannels.map((data) => data.label);

    let lastValues =
      chartChannel !== undefined
        ? chartChannel.map(
          (header, index) => {
            const matchedChannel = availableChannels.find(
              (channel) => channel.label === header
            );
            return matchedChannel?.data?.slice(-1)[0]
          }
        )
        : availableChannels.map((header, index) => header.data.slice(-1)[0]);

    let barChartLabels = [...availableChannelsNames];
    let groupChannels = [];

    if (channelsGroup) {
      allChannelGroups.forEach((group) => {
        if (group.groupName === channelsGroup) {
          groupChannels = group.channels;
        }
      })
    }


    if (groupChannels?.length > 0) {
      barChartLabels = [...groupChannels];
      lastValues = groupChannels.length > 0
        ? groupChannels.map(
          (header, index) => {
            const matchedChannel = availableChannels.find(
              (channel) => channel.label === header
            );
            return matchedChannel?.data?.slice(-1)[0]
          }
        )
        : availableChannels.map((header, index) => header.data.slice(-1)[0]);
    }


    if (chartChannel?.length > 0) {
      barChartLabels = [...chartChannel];
      lastValues = chartChannel !== undefined
        ? chartChannel.map(
          (header, index) => {
            const matchedChannel = availableChannels.find(
              (channel) => channel.label === header
            );
            return matchedChannel?.data?.slice(-1)[0]
          }
        )
        : availableChannels.map((header, index) => header.data.slice(-1)[0]);

    }

    const newBarChartData = {
      labels: barChartLabels,
      datasets: [
        {
          label: "Available Channels",
          data: lastValues,
          backgroundColor: dataArrLive.map(() => getRandomColor()),
        },
      ],
    };

    setNewChartData(newBarChartData);
  }, [dateTimesLive, selectedTabIndex, chartChannel]);

  return (
    <div>
      {newChartData && newChartData.labels ? (
        <Bar data={newChartData} />
      ) : (
        <p>Loading chart data...</p>
      )}
    </div>
  );
};

export { BarChart, NewBarChart };